import store from "@/store";

export async function setLocalStorage(key, value) {
    let _str_value = JSON.stringify(value)
    await window.localStorage.setItem(key, _str_value)
    store.state[key] = value
}


export function getLocalStorage(key, defaultValue = '') {
    let value = window.localStorage.getItem(key)
    return value ? JSON.parse(value) : defaultValue
}
export const downloadFile = (data, fileName) => {
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
}


//1 财务专家 2 业务专家 3 管理专家
export const expert_role_types = [
    {
        value: 1,
        label: '财务专家'
    },
    {
        value: 2,
        label: '业务专家'
    },
    {
        value: 3,
        label: '管理专家'
    }
]